<script>
import { Carousel, Slide } from "vue-carousel";
export default {
    props: {
        reportId: Number,
        reportFrom: {
            type: String,
            default: 'planning'
        }
    },
    components: {
        Carousel,
        Slide
    },
    data(){
        return {
            reportList: false,
            slideNum: 1,
            selectedCampus: null,
            allCampus: [],
            fundSources: [],
            fsLoading: false,
            selectedFundSource: null,
            preSelection: 'all',
            groupCampus: "",
        }
    },
    created(){
        this.allCampus = this.$store.state.decrypt.campusAccessList();
    },
    methods: {
        async getFundSources(campusId){
            this.fsLoading = true;
            await this.$store
                .dispatch("fundsource/GetFundSourcesByCampusId", campusId)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.fundSources = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            
            this.fsLoading = false;
        },
        renderSelection() {
            this.reportList = true;
            this.slideNum = 1;
            this.$nextTick(() => {
                this.$refs.carousel.goToPage(0);
            });
        },
        goBackToSelection() {
            this.slideNum = 1;
            this.reportSelection = 0;
            this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
        },
        goToSelection(type) {
            this.slideNum = 2;
            this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
            if (type === "campus") {
                this.reportSelection = 1;
            } else if (type === 'lib') {
                this.reportSelection = 2;
            } else if (type === 'pre') {
                this.reportSelection = 3;
            }
        },
        printLIB(){
            this.reportList = false;
            this.$emit('printLIB', this.selectedFundSource);
        },
        printPRE(){
            let url = "";
            let routeVar = [];
            this.reportList = false;
            if(this.preSelection == 'all'){
                url = "api/Report/PrePlanning/PRE/Summary";
                routeVar = [this.$store.state.data.cycle];
            }else if(this.preSelection == 'campus'){
                url = "api/Report/PrePlanning/PRE/Campus";
                routeVar = [this.$store.state.data.cycle, this.selectedCampus];
            }else{
                url = "api/Report/PrePlanning/PRE/FundSource";
                routeVar = [this.$store.state.data.cycle, this.selectedFundSource];
            }
            this.$emit('printPRE', {url, routeVar});
        },
        async printBar1PRO(type, id) {
            this.reportList = false;
            var apiUrl = "";
            let routeVar = [this.$store.state.data.cycle, id];
            if (type === "campus") {
                apiUrl = `api/Report/Planning/Bar1/PhysicalReport/Operation/Campus`;
            } else if(type === 'all') {
                apiUrl = `api/Report/Planning/Bar1/PhysicalReport/Operation/Summary`;
                routeVar = [this.$store.state.data.cycle]
            }else {
                apiUrl = `api/Report/Planning/Bar1/PhysicalReport/Operation/DeliveryUnit`;
            }
            this.$emit('printBar1PRO', {apiUrl, routeVar});
        },
        async printVariance() {
            this.reportList = false;
            var apiUrl = `api/Report/Planning/Target/Variance`;
            let routeVar = [];
            this.$emit('printVariance', {apiUrl, routeVar});
        },
        printAPP(){
            this.reportList = false;
            this.$emit('printAPP')
        }
    }
}
</script>
<template>
    <div>
        <button
            type="button"
            class="btn btn-purple me-1"
            :id="`select-report-${reportId}`"
            @click="renderSelection"
        >
            <i class="bx bx-printer me-1"></i>Reports
        </button>
        <b-popover
            :target="`select-report-${reportId}`"
            triggers="click"
            placement="left"
            :show.sync="reportList"
            custom-class="popover-report"
        >
            <template v-slot:title>
                <div
                    class="
                        d-flex
                        align-items-center
                        justify-content-between
                    "
                >
                    <small>Report List</small>
                    <span
                        class="
                            bx bx-x
                            font-size-14
                            cursor-pointer
                        "
                        @click="reportList = false"
                    ></span>
                </div>
            </template>
            <carousel
                ref="carousel"
                class="events navs-carousel custom-carousel"
                id="timeline-carousel"
                :navigation-enabled="false"
                :pagination-enabled="false"
                :perPage="1"
                :autoplay="false"
                :minSwipeDistance="0"
                :mouseDrag="false"
            >
                <slide>
                    <div v-if="slideNum == 1">
                        <div>
                            <a
                                href="javascript:void(0);"
                                @click="goToSelection('lib')"
                                class="
                                    font-size-12
                                    text-dark
                                    hoverable-link
                                "
                                >{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} LIB</a
                            >
                        </div>
                        <template v-if="reportFrom === 'planning'">
                            <hr class="my-2"/>
                            <div >
                                <a
                                    href="javascript:void(0);"
                                    @click="goToSelection('campus')"
                                    class="
                                        font-size-12
                                        text-dark
                                        hoverable-link
                                    "
                                >
                                    <div class="line-height-1">
                                        Physical Report
                                        Operations
                                    </div>
                                    <small>by {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</small>
                                </a>
                            </div>
                            <hr class="my-2" />
                            <div>
                                <a
                                    href="javascript:void(0);"
                                    @click="printBar1PRO('all')"
                                    class="
                                        font-size-12
                                        text-dark
                                        hoverable-link
                                    "
                                >
                                    <div class="line-height-1">
                                        Physical Report
                                        Operations
                                    </div>
                                    <small>Summary</small>
                                </a>
                            </div>
                            <hr class="my-2"/>
                            <div>
                                <a
                                    href="javascript:void(0);"
                                    @click="printVariance"
                                    class="
                                        font-size-12
                                        text-dark
                                        hoverable-link
                                    "
                                >
                                    <div class="line-height-1">
                                        Operations Template
                                        <span class="badge bg-danger">New</span>
                                    </div>
                                </a>
                            </div>
                        </template>
                        <hr class="my-2"/>
                        <div >
                            <a
                                href="javascript:void(0);"
                                @click="printAPP"
                                class="
                                    font-size-12
                                    text-dark
                                    hoverable-link
                                "
                            >
                                <div>
                                    Indicative Annual Procurement Plan
                                </div>
                            </a>
                        </div>
                        <hr class="my-2" />
                        <div>
                            <a
                                href="javascript:void(0);"
                                @click="goToSelection('pre')"
                                class="
                                    font-size-12
                                    text-dark
                                    hoverable-link
                                "
                            >
                                <div>
                                    Program of Receipts &amp; Expenditures
                                </div>
                            </a>
                        </div>
                    </div>
                </slide>
                <slide>
                    <div v-if="slideNum == 2">
                        <a
                            href="javascript:void(0);"
                            class="
                                text-dark
                                d-flex
                                align-items-center
                            "
                            @click="goBackToSelection"
                            ><i
                                class="
                                    bx bx-left-arrow-alt
                                    me-1
                                "
                            ></i
                            >Go back to selection</a
                        >
                        <div v-if="reportSelection == 1">
                            <select 
                                class="form-select mt-2 mb-2"
                                v-model="groupCampus"
                            >
                                <option value="">Select {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</option>
                                <option
                                    v-for="x in allCampus"
                                    :key="x.Id"
                                    :value="x.Id"
                                >
                                    {{ x.CampusName }}
                                </option>
                            </select>
                            <button
                                type="button"
                                @click="printBar1PRO('campus', groupCampus)"
                                class="
                                    btn
                                    btn-purple
                                    btn-sm
                                    btn-block
                                    mt-2
                                "
                                v-if="groupCampus > 0"
                            >
                                <i
                                    class="
                                        bx bx-printer
                                        me-1
                                    "
                                ></i>
                                Print Report
                            </button>
                        </div>
                        <div v-if="reportSelection == 2">
                            <div class="mt-1">
                                <div class="mb-2">
                                    <div class="mb-1">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</div>
                                    <select 
                                        class="form-select mt-2 mb-2"
                                        v-model="selectedCampus"
                                        @change="getFundSources(selectedCampus)"
                                    >
                                        <option :value="null">Select {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</option>
                                        <option
                                            v-for="x in allCampus"
                                            :key="x.Id"
                                            :value="x.Id"
                                        >
                                            {{ x.CampusName }}
                                        </option>
                                    </select>
                                </div>
                                <div class="mb-2">
                                    <div class="mb-1">Fund Source</div>
                                    <template v-if="fsLoading">
                                        <div>Loading...</div>
                                    </template>
                                    <template v-else>
                                        <select 
                                            class="form-select mt-2 mb-2"
                                            v-model="selectedFundSource"
                                        >
                                            <option :value="null">Select Fund Source</option>
                                            <option
                                                v-for="x in fundSources"
                                                :key="x.id"
                                                :value="x.id"
                                            >
                                                {{ x.sourceName }}
                                            </option>
                                        </select>
                                    </template>
                                </div>
                            </div>
                            <button
                                type="button"
                                @click="printLIB"
                                class="
                                    btn
                                    btn-purple
                                    btn-sm
                                    btn-block
                                    mt-2
                                "
                                v-if="selectedFundSource != null"
                            >
                                <i
                                    class="
                                        bx bx-printer
                                        me-1
                                    "
                                ></i>
                                Print Report
                            </button>
                        </div>
                        <div v-if="reportSelection == 3">
                            <div class="mt-1">
                                <div class="mb-2">
                                    <select 
                                        class="form-select mt-2 mb-2"
                                        v-model="preSelection"
                                    >
                                        <option value="all">All</option>
                                        <option value="campus">By {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</option>
                                        <option value="fundsource">By Fund Source</option>
                                    </select>
                                </div>
                                <div class="mb-2" v-if="preSelection == 'campus' || preSelection == 'fundsource'">
                                    <div class="mb-1">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</div>
                                    <select 
                                        class="form-select mt-2 mb-2"
                                        v-model="selectedCampus"
                                        @change="getFundSources(selectedCampus)"
                                    >
                                        <option :value="null">Select {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}</option>
                                        <option
                                            v-for="x in allCampus"
                                            :key="x.Id"
                                            :value="x.Id"
                                        >
                                            {{ x.CampusName }}
                                        </option>
                                    </select>
                                </div>
                                <div class="mb-2" v-if="preSelection == 'fundsource' && selectedCampus != null">
                                    <div class="mb-1">Fund Source</div>
                                    <template v-if="fsLoading">
                                        <div>Loading...</div>
                                    </template>
                                    <template v-else>
                                        <select 
                                            class="form-select mt-2 mb-2"
                                            v-model="selectedFundSource"
                                        >
                                            <option :value="null">Select Fund Source</option>
                                            <option
                                                v-for="x in fundSources"
                                                :key="x.id"
                                                :value="x.id"
                                            >
                                                {{ x.sourceName }}
                                            </option>
                                        </select>
                                    </template>
                                </div>
                            </div>
                            <button
                                type="button"
                                @click="printPRE"
                                class="btn btn-purple btn-sm btn-block mt-2"
                            >
                                <i class="bx bx-printer me-1"></i>
                                Print Report
                            </button>
                        </div>
                    </div>
                </slide>
            </carousel>
        </b-popover>
    </div>
</template>
<style lang="scss">
.p-custom-class .popover-body {
  padding: 0 !important;
  border: 0 !important;
}

.p-custom-class .list-group-item {
  border: 0 !important;
}
</style>